import type { NavigateOptions } from 'react-router-dom';
import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useSupportPageRedirect = () => {
  const { doRedirectOnPrevPage, doRedirectWithSavePageUrl, doSavePageUrl, prevPageUrl } =
    usePagesRedirect('supportPage');

  const redirectToSupportPage = (options?: NavigateOptions) =>
    doRedirectWithSavePageUrl('/support', options);

  return {
    doSavePageUrl,
    redirectToSupportPage,
    prevPageUrl,
    doRedirectOnPrevPage,
  };
};
